/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { VoucherDto, VoucherValidationDto } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class VoucherService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags VoucherService
   * @name ValidateVoucher
   * @summary Validate Voucher
   * @request POST:/v1/vouchers/validate
   * @secure
   */
  validateVoucher = (data: VoucherValidationDto, params: RequestParams = {}) =>
    this.http.request<VoucherDto, any>({
      path: `/v1/vouchers/validate`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
